export const ALL_HORIZON_REGIONS = 'Both' as const;

export type HorizonRegion = 'US' | 'UK';
export type HorizonOptOutType = 'Worth' | 'Global Payments';

/** A Horizon configuration supported by the opt-out tracker. */
export interface HorizonConfig {
  id: number;
  name: 'Horizon_US' | 'Horizon_UK';
  region: HorizonRegion;
}

/** The IngestApp fields required to build an opt-out tracker row. */
export interface HorizonIngestApp {
  appUid: string;
  companyName: string;
  email: string;
  region: HorizonConfig['region'];
}

/** A normalized EventLog candidate for an opt-out. */
export interface HorizonEventLog {
  appUid: string;
  eventDateUTC: string;
  eventType: string;
  eventDescription: string;
}

/** Opt-out details progressively loaded for one Horizon application. */
export interface HorizonOptOutDetails {
  optOutReason: string;
  optOutTimeUTC: string;
  type: HorizonOptOutType;
}

/** Calendar-date bounds used to filter Horizon opt-out events. */
export interface HorizonOptOutDateRange {
  endDate: string;
  startDate: string;
}

export type HorizonRegionFilter = typeof ALL_HORIZON_REGIONS | HorizonRegion;

type HorizonOptOutDetailStatus = 'loading' | 'loaded' | 'error';

/** A disqualified IngestApp with progressively loaded opt-out details. */
export interface HorizonOptOutDisplayRow extends HorizonIngestApp {
  detailStatus: HorizonOptOutDetailStatus;
  optOutReason?: string;
  optOutTimeUTC?: string;
  type?: HorizonOptOutDetails['type'];
}
